import { format as formatDate } from 'date-fns';
import { memo } from 'react';
import { type ReactDatePickerCustomHeaderProps } from 'react-datepicker';

import { ChevronLeftIcon, ChevronRightIcon } from '@air/design-icons';
import { IconButton } from '@air/primitive-icon-button';

export type DateInputHeaderProps = ReactDatePickerCustomHeaderProps;

export const DateInputHeader = memo(
  ({ date, prevMonthButtonDisabled, nextMonthButtonDisabled, increaseMonth, decreaseMonth }: DateInputHeaderProps) => {
    return (
      <div className="mb-3 flex items-center justify-between">
        <IconButton
          adsIcon
          appearance="ghost"
          color="gray"
          disabled={prevMonthButtonDisabled}
          icon={ChevronLeftIcon}
          label="Show previous month"
          onClick={decreaseMonth}
          size="small"
        />
        <div className="font-medium text-12 text-gray-11">{formatDate(date, 'MMMM yyyy')}</div>
        <IconButton
          adsIcon
          appearance="ghost"
          color="gray"
          disabled={nextMonthButtonDisabled}
          icon={ChevronRightIcon}
          label="Show next month"
          onClick={increaseMonth}
          size="small"
        />
      </div>
    );
  },
);

DateInputHeader.displayName = 'DateInputHeader';
